import axios from 'axios';
import fetch from '../api/FetchInterceptor';
import type { Response } from 'domain/Response';

export const makeSignInRequest = (form: {
  email: string;
  password: string;
}): Response<{ data: { token: string } }> =>
  axios.post(`${import.meta.env.VITE_API}/auth/login`, form);

export const makeLogoutRequest = (): Promise<void> => fetch.post(`/auth/logout`);
